<template>
  <a
    id="cta_ccg_submenu"
    href="https://culturalcapitalgroup.es/?utm_source=wegow&utm_medium=cta_submenu&utm_campaign=ccg_2025"
    target="_blank"
    rel="noopener noreferrer"
    class="promoter-banner"
    :style="{ top: bannerTop }"
  >
    <div class="banner-content">
      <span class="banner-text">
        <strong>¡PROMOTOR!</strong> Recupera parte de tus gastos de 2025 con las deducciones fiscales
      </span>
      <span class="banner-button">Más información</span>
    </div>
  </a>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useScrollHide } from "@/composables/useScrollHide";

const { hideOnScroll } = useScrollHide(132);
const windowWidth = ref(window.innerWidth);

onMounted(() => {
  const updateWidth = () => {
    windowWidth.value = window.innerWidth;
  };
  window.addEventListener("resize", updateWidth);
  updateWidth();
});

const bannerTop = computed(() => {
  if (windowWidth.value < 769) {
    return "72px";
  }
  return hideOnScroll.value ? "72px" : "132px";
});
</script>

<style scoped lang="scss">
.promoter-banner {
  display: block;
  width: 100%;
  background-color: $topazsobrenegro;
  padding: 16px 24px;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
  position: sticky;
  top: 72px;
  z-index: 8;
  transition: top 0.3s ease-in-out;

//   &:hover {
//     opacity: 0.9;
//   }

  .banner-content {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    gap: 24px;
    text-align: center;

    @media screen and (max-width: $screen-md) {
      flex-direction: column;
      align-items: center;
      gap: 12px;
      text-align: center;
    }
  }

  .banner-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: $backgroundBlack;
    text-align: center;
    
    strong {
      font-weight: 700;
    }

    @media screen and (max-width: $screen-md) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .banner-button {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: $white;
    white-space: nowrap;
    padding: 10px 20px;
    background-color: rgba($backgroundBlack, 0.6);
    border: none;
    border-radius: 9999px;
    transition: background-color 0.2s ease, opacity 0.2s ease;
    cursor: pointer;

    &:hover {
      background-color: rgba($backgroundBlack, 0.7);
    }

    @media screen and (max-width: $screen-md) {
      font-size: 12px;
      padding: 8px 16px;
    }
  }
}
</style>

